import { NgModule } from '@angular/core';
import {
  StrikeSkewChartComponent,
  TimeSkewChartComponent,
  AtmIvComponent,
  DeltaChartComponent,
  IVX30ChartComponent,
  SkewSurfaceComponent,
  IvxChartComponent,
  ZingChartComponent,
  SkewChartComponent,
  ContractViewerChartComponent
} from './components';
import { ChartsService } from './charts.service';
import { SharedModule } from '../shared/shared.module';
import {
  DxScrollViewModule,
  DxButtonModule
} from 'devextreme-angular';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FutCurveComponent } from './components/fut-curve/fut-curve.component';
import { TuiLoaderModule } from '@taiga-ui/core';

@NgModule({
  declarations: [
    IVX30ChartComponent,
    StrikeSkewChartComponent,
    TimeSkewChartComponent,
    AtmIvComponent,
    DeltaChartComponent,
    IVX30ChartComponent,
    SkewSurfaceComponent,
    IvxChartComponent,
    FutCurveComponent,
    ZingChartComponent,
    SkewChartComponent,
    ContractViewerChartComponent
  ],
  exports: [
    IVX30ChartComponent,
    StrikeSkewChartComponent,
    TimeSkewChartComponent,
    AtmIvComponent,
    DeltaChartComponent,
    IVX30ChartComponent,
    SkewSurfaceComponent,
    IvxChartComponent,
    FutCurveComponent,
    ContractViewerChartComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DxScrollViewModule,
    DxButtonModule,
    ReactiveFormsModule,
    TuiLoaderModule
  ],
  providers: [ChartsService]
})

export class ChartsModule {
}
